<template>
  <div :class="classList">
    <component :is="headlineTag" :class="textClassList" v-bind="$attrs">
      <slot>default headline</slot>
    </component>
  </div>
</template>

<script>
export default {
  name: "st-headline",
  inheritAttrs: false,
  props: {
    level: {
      type: Number,
      default: 1,
      validator(val) {
        return val > 0 && val < 7;
      },
    },
    font: {
      type: String,
      validator(font) {
        return ["primary", "secondary"].includes(font);
      },
    },
    color: {
      type: String,
      validator(value) {
        return ["secondary"].includes(value);
      },
    },
    displayBorder: Boolean,
    thin: Boolean,
    class: {
      type: String,
    },
  },
  computed: {
    headlineTag() {
      const headlineTagMap = {
        1: "h1",
        2: "h2",
        3: "h3",
        4: "h4",
        5: "h5",
        6: "h6",
      };
      return this.level ? headlineTagMap[this.level] : "h1";
    },
    classList() {
      const headline = "st-headline";
      return [
        headline,
        this.class,
        this.displayBorder && `${headline}--with-border`,
      ];
    },
    textClassList() {
      const text = "st-headline--text";
      return [
        text,
        `${text}--${this.headlineTag}`,
        this.font && `${text}--font-${this.font}`,
        this.color && `${text}--color-${this.color}`,
        this.thin && `${text}--thin`,
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-headline {
  color: var(--text-color-primary);

  &--with-border {
    padding-bottom: rem-calc(24);
    border-bottom: rem-calc(1) solid var(--border-color-tertiary);
  }

  &--text {
    margin: 0;
    font-weight: 700;
    line-height: 150%;
    font-family: var(--font-secondary);
    color: var(--text-color-primary);

    &--font-primary {
      font-family: var(--font-primary);
    }
    &--color-secondary {
      color: var(--text-color-quinary);
    }
    &--h1 {
      font-size: rem-calc(24);
      @include medium {
        font-size: rem-calc(32);
      }
      @include large {
        font-size: rem-calc(42);
      }
    }
    &--h2 {
      font-size: rem-calc(24);
      @include medium {
        font-size: rem-calc(32);
      }
    }
    &--h3 {
      font-size: rem-calc(24);
    }
    &--h4 {
      font-size: rem-calc(18);
    }
    &--h5 {
      font-size: rem-calc(16);
    }
    &--h6 {
      font-size: rem-calc(14);
    }
    &--thin {
      font-weight: 400;
    }
  }
}
</style>
